/**
 * @license
 * @copyright Copyright Motili Inc., 2023 All Rights Reserved
 */

import { useNavigate } from 'react-router-dom';
import Finances from './Finances';

export default function FinancesPage() {
    const navigate = useNavigate();
    const handleBackClick = () => navigate(-1);
    const handleNextClick = () => navigate('/client/w9');

    return (
        <Finances
            handleBackClick={handleBackClick}
            handleNextClick={handleNextClick}
        />
    );
}
